import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import rushLogo from "../assets/png/rush-logo.png";
import { useAuthStore } from "../features/auth/authStore";

export default function SplashScreen() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isAuthenticated) {
        navigate("/home");
      } else {
        navigate("/auth");
      }
    }, 2000); // 2 seconds
    return () => clearTimeout(timer);
  }, [navigate, isAuthenticated]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <img src={rushLogo} alt="Rush Logo" className="h-10 sm:h-5 mx-auto" />
    </div>
  );
}
